import React from 'react';
import AppCard from './AppCard';
import logoImage from '../assets/IA_logo_white.png';
import '../styles/Landing.css';

const Landing = () => {
  console.log('MUNI_URL:', process.env.REACT_APP_MUNI_URL);
  const apps = [
    {
      id: 'comm',
      title: 'Commercial Proposal Builder',
      description: 'Create and manage comprehensive commercial proposals with advanced tools and analytics',
      url: 'https://hub.interagency.biz/comm'
    },
    {
      id: 'muni',
      title: 'Municipal',
      description: 'Access municipal services like RFPs, SF330s and team management administrative tools',
      url: process.env.REACT_APP_MUNI_URL || 'https://hub.interagency.biz/muni.html'
    }
  ];

  return (
    <div className="landing-container">
      <div className="landing-content">
        <img src={logoImage} alt="IA Logo" className="logo" style={{width: '50px', height: '70px', display: 'block', margin: '0 auto 20px auto'}} />
        
        <h1>Choose Application</h1>
        <p className="subtitle">Select a workspace to continue</p>
        
        <div className="cards-container">
          {apps.map(app => (
            <AppCard key={app.id} app={app} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Landing;